export class BrowserAddressBarWithoutReload {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get addressBar() {
        return this.parent;
    }
    setUrl(url, title = '', data = {}) {
        if (typeof url === 'string') {
            history.pushState(data, title, url);
        }
        else {
            console.log('pushState', url.toString());
            history.pushState(data, title, url.toString());
        }
        this.addressBar.browserLocationChangedHandler(); // popstate listener is not triggered
    }
}
